<template>
  <div v-if="data.total" class="text-left border-t-2 mt-15 py-8">
    <p class="text-lg font-bold">{{ $t("热门资讯") }}</p>
    <ul class="flex flex-wrap justify-between pt-4">
      <li
        v-for="item in data.items"
        :key="item.id"
        @click="goNewsDetail(item.id)"
      >
        {{ item.title }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
  },
  setup(props, ctx) {
    const goNewsDetail = (id) => {
      ctx.root.$router.push({
        name: "newsDetail",
        query: { id: id, tag: "newsDetail" },
      });
    };
    return { goNewsDetail };
  },
};
</script>
<style scoped lang="scss">ul li {
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1.25rem;
  list-style-type: disc;
  padding-bottom: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(51, 51, 51, var(--tw-text-opacity));
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 24rem;
}
ul li::before {
  content: "•";
  color: #c4c4c4;
  padding-right: 0.2rem;
}
ul::after {
  display: block;
  content: "";
  width: 24rem;
  height: 0px;
}</style>